import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Typography, HtmlEmailViewer} from 'views/components';
import {Author, Translate, translate} from 'views/module';

import parseSesEmail from 'utils/miscellaneous/email/parse_ses_email';
import moment from 'moment';

const EMPTY_EMAIL = {
  from: '',
  to: '',
  replyTo: '',
  subject: '',
  date: '',
  html: '',
  text: '',
};

const EmailMessage = (props) => {
  const [parsedEmail, setParsedEmail] = React.useState(EMPTY_EMAIL);

  const {
    email,
    parsedEmail: parsedEmailProp,
    timestampLabel,
  } = props;

  React.useEffect(() => {
    if (parsedEmailProp) {
      setParsedEmail(parsedEmailProp);
      return;
    }

    let isActive = true;

    setParsedEmail(EMPTY_EMAIL);

    parseSesEmail(email).then((value) => {
      if (!isActive) {
        return;
      }

      setParsedEmail(value);
    });

    return () => {
      isActive = false;
    };
  }, [email, parsedEmailProp]);

  const emailMetadata = [
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.From'),
      value: parsedEmail.from,
    },
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.Subject'),
      value: parsedEmail.subject,
    },
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.To'),
      value: parsedEmail.to,
    },
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.ReplyTo'),
      value: parsedEmail.replyTo,
    },
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.Date'),
      value: moment(parsedEmail.date).format(translate('timeFormat.VerboseDay')),
    },
  ].filter((item) => Boolean(item.value));

  return (
    <Stack
      sx={{
        py: {md: 2, xs: 1},
      }}
      spacing={1}
    >
      <Author
        fullName=''
        timestampLabel={timestampLabel}
      />
      <Stack spacing={0.5}>
        {
          emailMetadata.map((item) => (
            <Typography
              key={item.label}
              variant='body2'
              sx={{
                color: 'text.secondary',
                wordBreak: 'break-word',
              }}
            >
              <Box component='span' sx={{fontWeight: 500}}>
                {`${item.label}: `}
              </Box>
              {item.value}
            </Typography>
          ))
        }
      </Stack>
      <HtmlEmailViewer
        html={parsedEmail.html}
        text={parsedEmail.text}
        showMoreLabel={<Translate expression='generic.ShowMore' />}
        showLessLabel={<Translate expression='generic.ShowLess' />}
      />
    </Stack>
  );
};
EmailMessage.propTypes = {
  email: PropTypes.string,
  parsedEmail: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
    replyTo: PropTypes.string,
    subject: PropTypes.string,
    date: PropTypes.string,
    html: PropTypes.string,
    text: PropTypes.string,
  }),
  timestampLabel: PropTypes.string.isRequired,
};

export default React.memo(EmailMessage);
